module.exports = __webpack_public_path__ + "static/img/zh_HANT2.9e25553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zh_HANT2.png
// module id = egFq
// module chunks = 1